<template>
  <div
    v-if="formattedItems.length"
    :class="$options.name"
  >
    <span>Данный тег уже используется следующими сущностями:</span>

    <div v-for="(entity, key) in formattedItems" :key="key">
      <p>
        <b>{{ entity.name }}: </b>

        <span>{{ entity.items }}</span>
      </p>
    </div>
  </div>
</template>

<script>

const itemsKeysMap = {
  icons: 'Иконки',
};

export default {
  name: 'tag-touched-entities',

  props: {
    items: {
      type: Array,
      default: null,
    },
  },

  computed: {
    formattedItems() {
      return this.items
        .filter(item => item.items?.length && itemsKeysMap[item.name])
        .reduce((acc, val) => {
          acc.push({
            name: itemsKeysMap[val.name],
            items: val.items.map(i => i.name).join(', '),
          });

          return acc;
        }, []);
    },
  },
};

</script>
